const LocalStorage = require('./localStorage');
const CookieStorage = require('./cookieStorage');
const Logger = require('../utils/logger');

function Storage(options) {
  this.log = new Logger();
  this.storage = new CookieStorage(options);

  // Try to use localStorage. Will throw an error if not available.
  try {
    var storage = new LocalStorage();
    this.storage = storage;
  } catch (e) {
    this.log.warn(e);
    this.log.warn('LocalStorage is not available. Using cookies instead.');
  }
}

Storage.prototype.getItem = function(key) {
  const value = this.storage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

Storage.prototype.setItem = function(key, val) {
  const json = JSON.stringify(val);
  return this.storage.setItem(key, json);
};

Storage.prototype.removeItem = function(key) {
  return this.storage.removeItem(key);
};

module.exports = Storage;
